export const PASSWORD_MIN_LENGTH = 8;
export const PASSWORD_MAX_LENGTH = 256;

const COGNITO_SPECIAL_RE = /[\^$*.[\]{}()?\-"!@#%&/,><':;|_~`+=\\]/;

export const PASSWORD_POLICY_TOOLTIP =
  "8 à 256 caractères, dont au moins une majuscule, une minuscule, un chiffre et un caractère spécial (! @ # ? * …). Pas d'espace au début ni à la fin.";

export const PASSWORD_POLICY_FALLBACK =
  "Le mot de passe doit faire de 8 à 256 caractères, avec au moins une majuscule, une minuscule, un chiffre et un caractère spécial, sans espace au début ni à la fin.";

export function validateAccountPassword(password) {
  const value = String(password || "");
  if (value.length < PASSWORD_MIN_LENGTH) {
    return {
      ok: false,
      message: `Le mot de passe doit contenir au moins ${PASSWORD_MIN_LENGTH} caractères.`,
    };
  }
  if (value.length > PASSWORD_MAX_LENGTH) {
    return {
      ok: false,
      message: `Le mot de passe ne peut pas dépasser ${PASSWORD_MAX_LENGTH} caractères.`,
    };
  }
  if (value !== value.trim()) {
    return {
      ok: false,
      message: "Le mot de passe ne doit pas commencer ni se terminer par un espace.",
    };
  }
  if (!/[A-Z]/.test(value)) {
    return { ok: false, message: "Le mot de passe doit contenir au moins une majuscule." };
  }
  if (!/[a-z]/.test(value)) {
    return { ok: false, message: "Le mot de passe doit contenir au moins une minuscule." };
  }
  if (!/[0-9]/.test(value)) {
    return { ok: false, message: "Le mot de passe doit contenir au moins un chiffre." };
  }
  if (!COGNITO_SPECIAL_RE.test(value)) {
    return {
      ok: false,
      message: "Le mot de passe doit contenir au moins un caractère spécial.",
    };
  }
  return { ok: true };
}
